import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=9eb613d8&scoped=true"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"
import style0 from "./Cotizacion.vue?vue&type=style&index=0&id=9eb613d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb613d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9eb613d8')) {
      api.createRecord('9eb613d8', component.options)
    } else {
      api.reload('9eb613d8', component.options)
    }
    module.hot.accept("./Cotizacion.vue?vue&type=template&id=9eb613d8&scoped=true", function () {
      api.rerender('9eb613d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/cotejo/Cotizacion.vue"
export default component.exports